module.exports = __webpack_public_path__ + "static/media/new-metronome.b9abc8a0.mp3";